<div class="wrapper">
    <div class="top-ribbon"></div>
<div class="layout">
    <div class="error-screen">
        <p *ngIf="!isAcura" class="error-text">Your remote services trial is expiring soon.<br>Subscribe to keep using these HondaLink features <br>from Manage Features on the app.</p>
        <p *ngIf="isAcura"  class="error-text">Your remote services trial is expiring soon.<br>Subscribe to keep using these AcuraLink features <br>from Manage Features on the app.</p>
        <p class="error-text2">When you put the car in drive, <br> this screen will switch to the normal mode</p>
    </div>
</div>
</div>